var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container home__container"},[_c('aside',[_c('Navbar')],1),_c('div',{staticClass:"home-feedbacks"},[_c('FeedbackWrapper')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }